import { z } from 'zod'
import { oc } from '@orpc/contract'
import { billingCaseDtoSchema } from './update-case.contract'

// On-demand point refresh of one case from FHIR (also the backend of the legacy page's
// "Process in V2" button). null = encounter not capturable or not found.
export const billingV2SyncCase = oc
  .route({ method: 'POST', path: '/v2/billing/sync-case' })
  .input(z.object({ encounterId: z.string() }))
  .output(z.object({ case: billingCaseDtoSchema.nullable() }))
